import { render, staticRenderFns } from "./CadastrarNovoPaciente.vue?vue&type=template&id=d49e5016&"
import script from "./CadastrarNovoPaciente.vue?vue&type=script&lang=js&"
export * from "./CadastrarNovoPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports